import { gql } from "@apollo/client";

/**
 * ZBERNA FAKTURACIA, mutacie volane priamo z okna Zakazky.
 *
 * Ziadna samostatna obrazovka tu nie je zamerne: zakazky sa vyfiltruju
 * a zaskrtnu v zozname a rovno sa z nich vystavi faktura.
 *
 * Obe hromadne mutacie vracaju aj `preskocene`, teda zakazky, ktore sa
 * vyfakturovat nedali, aj s dovodom. Bez toho by sa dalo zaskrtnut dvadsat
 * zakaziek, vyfakturovat patnast a nikto by o tom nevedel.
 */

const HROMADNY_VYSLEDOK = `
  sucessful
  message
  faktury {
    invoiceId
    number
    serviceId
    carOwnerId
    company
    pocetZakaziek
    netto
    dph
    brutto
  }
  preskocene {
    serviceId
    dovod
  }
`;

/** Zberna faktura z vybranych zakaziek. Jedna faktura na majitela. */
export const ISSUE_COLLECTIVE_FROM_SERVICES = gql`
  mutation issueCollectiveFromServices(
    $tokenMutation: String!
    $serviceIds: [Int]
    $issueDate: String
    $paymentType: String
    $periodFrom: String
    $periodTo: String
    $note: String
  ) {
    issueCollectiveFromServices(
      token: $tokenMutation
      serviceIds: $serviceIds
      issueDate: $issueDate
      paymentType: $paymentType
      periodFrom: $periodFrom
      periodTo: $periodTo
      note: $note
    ) {${HROMADNY_VYSLEDOK}}
  }
`;

/** Faktura po zakazke, teda ako doteraz, len na viacerych naraz. */
export const INVOICE_SERVICES_DIRECTLY = gql`
  mutation invoiceServicesDirectly(
    $tokenMutation: String!
    $serviceIds: [Int]
    $issueDate: String
    $paymentType: String
  ) {
    invoiceServicesDirectly(
      token: $tokenMutation
      serviceIds: $serviceIds
      issueDate: $issueDate
      paymentType: $paymentType
    ) {${HROMADNY_VYSLEDOK}}
  }
`;

/**
 * Dobropis. Jedina cesta, ako opravit uz vystavenu zbernu fakturu: riadky
 * su zmrazene, takze sa prepisat nedaju. Dobropis vezme dalsie cislo z toho
 * isteho radu a zakazky uvolni, takze sa daju vyfakturovat znova.
 */
export const CREATE_CREDIT_NOTE = gql`
  mutation createCreditNote($tokenMutation: String!, $invoiceId: Int, $reason: String) {
    createCreditNote(token: $tokenMutation, invoiceId: $invoiceId, reason: $reason) {
      sucessful
      message
      id
      number
    }
  }
`;
